export const DEFAULT_YOUTUBE_VIDEO_ID = "W5Trznre92c";

export const YOUTUBE_VIDEO_PIXEL_SIZE = Object.freeze({ width: 1024, height: 576 });
export const YOUTUBE_VIDEO_MESH_SIZE = Object.freeze({ width: 4, height: 2.25 });

const YOUTUBE_VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;
const RETIRED_DEFAULT_YOUTUBE_VIDEO_IDS = new Set(["jfKfPfyJRdk"]);

export function resolveYouTubeVideoId(value: string | null | undefined) {
  const candidate = value?.trim();
  if (!candidate) return DEFAULT_YOUTUBE_VIDEO_ID;
  if (YOUTUBE_VIDEO_ID_PATTERN.test(candidate)) {
    return RETIRED_DEFAULT_YOUTUBE_VIDEO_IDS.has(candidate) ? DEFAULT_YOUTUBE_VIDEO_ID : candidate;
  }

  try {
    const url = new URL(candidate);
    const hostname = url.hostname.toLowerCase().replace(/^www\./, "");
    let videoId: string | null = null;

    if (hostname === "youtu.be") {
      videoId = url.pathname.split("/").filter(Boolean)[0] ?? null;
    } else if (hostname === "youtube.com" || hostname.endsWith(".youtube.com")) {
      const pathParts = url.pathname.split("/").filter(Boolean);
      videoId = url.pathname === "/watch" ? url.searchParams.get("v") : pathParts[1] ?? null;
    }

    return videoId && YOUTUBE_VIDEO_ID_PATTERN.test(videoId) && !RETIRED_DEFAULT_YOUTUBE_VIDEO_IDS.has(videoId)
      ? videoId
      : DEFAULT_YOUTUBE_VIDEO_ID;
  } catch {
    return DEFAULT_YOUTUBE_VIDEO_ID;
  }
}

export function normalizeYouTubeSearchParam(value: string | null | undefined) {
  if (!value?.trim()) return null;
  const videoId = resolveYouTubeVideoId(value);
  return videoId === DEFAULT_YOUTUBE_VIDEO_ID ? null : videoId;
}

export function buildYouTubeEmbedUrl(videoId: string) {
  const safeVideoId = YOUTUBE_VIDEO_ID_PATTERN.test(videoId) ? videoId : DEFAULT_YOUTUBE_VIDEO_ID;
  return `https://www.youtube.com/embed/${safeVideoId}?enablejsapi=1&rel=0`;
}

export function hasMatchingYouTubeAspectRatios() {
  return YOUTUBE_VIDEO_PIXEL_SIZE.width * YOUTUBE_VIDEO_MESH_SIZE.height
    === YOUTUBE_VIDEO_PIXEL_SIZE.height * YOUTUBE_VIDEO_MESH_SIZE.width;
}
